module.exports = __webpack_public_path__ + "assets/img/logo.dab6b976.png";